<mat-tab-group class="mat-tab-group-principal" #generalTabs (selectedTabChange)="onTabChange($event)">
  <mat-tab #generalTab label="{{ 'executionEdit.general.title' | translate }}">

    <ng-template mat-tab-label>
      {{ 'executionEdit.general.title' | translate }}
    </ng-template>

    <form>
      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'executionEdit.general.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" class="flexwrap" fxLayout.xs="column">

            <div fxFlex>
              <div fxLayout="column">
                @if (execution.documentCode != null) {
                  <div fxFlex>
                    <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                      <div fxFlex>
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'executionEdit.general.documentCode.label' | translate
                          }}</mat-label>
                          <input matInput name="documentCode" [(ngModel)]="execution.documentCode"
                            disabled>
                        </mat-form-field>
                      </div>
                      @if (canEditDocumentCode() && canAdd()) {
                        <div fxFlex="65px" fxFlex.lt-md="50px"
                          >
                          <button mat-icon-button (click)="editDocumentCode()">
                            <mat-icon>mode_edit</mat-icon>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }

                <div fxFlex [hidden]="execution.id != null || !useExistingProtocol">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'executionEdit.general.protocol.label' | translate }}</mat-label>
                    <input matInput required [ngModel]="execution.idProtocol"
                      [disabled]="execution.id != null" #protocolAutocomplete
                      #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
                      (keyup)="lookupProtocol($event)" [ngModelOptions]="{standalone: true}">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                      [displayWith]="displayProtocol" (optionSelected)="onProtocolChange($event)">

                      @if (loadingAutocomplete$ | async) {
                        <mat-option>
                          <mat-spinner diameter="50" class="centerIcon"></mat-spinner>
                        </mat-option>
                      }

                      @if (!(loadingAutocomplete$ | async)) {
                        @for (prot of protocolsFiltered; track prot) {
                          <mat-option [value]="prot">
                            {{ displayProtocol(prot) }}
                          </mat-option>
                        }
                      }

                    </mat-autocomplete>
                    <mat-error>
                      {{ 'executionEdit.general.protocol.error' | translate }}
                    </mat-error>

                    <button matSuffix mat-icon-button color="accent" (click)="openSearchProtocol()">
                      <mat-icon style="font-size: large;">search</mat-icon>
                    </button>
                  </mat-form-field>
                </div>

                @if (execution.id != null && execution?.idProtocol != null) {
                  <div fxFlex>
                    <div fxFlex>
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'executionEdit.general.protocol.label' | translate
                        }}</mat-label>
                        <input matInput name="protocolDocumentCode"
                          [ngModel]="execution?.protocolDocumentCode" disabled>
                      </mat-form-field>
                    </div>
                    <div fxFlex="65px" fxFlex.lt-md="50px">
                      <button mat-icon-button (click)="downloadProtocolPdf()">
                        <mat-icon class="hidden-sm">cloud_download</mat-icon>
                      </button>
                    </div>
                  </div>
                }


                @if (execution?.id) {
                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <div fxFlex="50" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'executionEdit.general.test.label' | translate }}</mat-label>
                        <mat-select #selectTestPerformed [ngModelOptions]="{standalone: true}"
                          name="testPerformed" [(ngModel)]="execution.testPerformed" multiple
                          disabled>
                          @for (item of testsPerformed; track item) {
                            <mat-option
                              [value]="item.description">
                              {{ 'testQualification.title.' + item.description | translate }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex="50">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'executionEdit.general.clientDocumentCode.label' | translate
                        }}</mat-label>
                        <input matInput name="clientDocumentCode"
                          [(ngModel)]="execution.clientDocumentCode" [errorStateMatcher]="matcher">
                      </mat-form-field>
                    </div>
                  </div>
                }


              </div>
            </div>

            <div fxFlex>
              <div fxLayout="row" class="flexwrap" fxLayout.xs="column" [hidden]="execution.id == null">
                <div fxFlex="50" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'executionEdit.general.regUser.label' | translate }}</mat-label>
                    <input matInput name="regUser" disabled [ngModel]="execution.regUser">
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'executionEdit.general.modUser.label' | translate }}</mat-label>
                    <input matInput name="modUser" disabled [ngModel]="execution.modUser">
                  </mat-form-field>
                </div>
                <div fxLayout="row" class="flexwrap">
                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'executionEdit.general.regFc.label' | translate }}</mat-label>
                      <input matInput name="regFc" [ngModel]="execution.regFc | fixDate" disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'executionEdit.general.modFc.label' | translate }}</mat-label>
                      <input matInput name="modFc" [ngModel]="execution.modFc | fixDate" disabled>
                    </mat-form-field>
                  </div>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100%">
                  <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
                    [hidden]="execution.id == null">
                    <div fxFlex fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.general.status.label' | translate
                        }}</mat-label>
                        <input matInput name="status" disabled
                          value="{{ execution.id != null ? ('executionStatus.' + execution.statusTranslation | translate) : '' }}">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                @if (execution.currentVersion != null) {
                  <div fxFlex="100" fxFlex.lt-md="100%">
                    <div fxLayout="row">
                      <div fxFlex="50">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'executionEdit.general.currentVersion.label' |
                          translate }}</mat-label>
                          <input matInput name="currentVersion"
                            [ngModel]="execution.currentVersion" disabled>
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'executionEdit.general.signedVersion.label' |
                          translate }}</mat-label>
                          <input matInput name="signedVersion"
                            [ngModel]="execution.signedVersion" disabled>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

          </div>

        </mat-card-content>
      </mat-card>

      <mat-card class="card" [hidden]="execution.id == null">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'executionEdit.referenceDocs.title' | translate }}

            <button mat-icon-button color="accent" (click)="openNewRefDoc()">
              <mat-icon>add</mat-icon>
            </button>
          </mat-toolbar>

          <br />

          <div fxLayout="row">

            <div fxFlex fxFlex.lt-md="100%">

              <table mat-table matSort #refDocTable [dataSource]="execution.referenceDocs"
                style="width: 95%;">

                <!-- code Column -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'executionEdit.referenceDocs.code.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let item"> {{ item.code }} </td>
                </ng-container>

                <!-- name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'executionEdit.referenceDocs.name.label' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let item" style="white-space: pre;"> {{ item.name }} </td>
                </ng-container>

                <!-- Button edit Column -->
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                  <td mat-cell *matCellDef="let element; let refDocIndex = index">
                    <button mat-icon-button (click)="editRefDoc(refDocIndex)">
                      <mat-icon>mode_edit</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Button delete Column -->
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                  <td mat-cell *matCellDef="let element; let refDocIndex = index">
                    <button mat-icon-button (click)="removeRefDoc(refDocIndex)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColsRefDoc"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColsRefDoc;"></tr>

              </table>
            </div>
          </div>
        </mat-card-content>

      </mat-card>

      @if (this.execution?.idProtocol) {
        <mat-card class="card">
          <mat-card-content>
            <mat-toolbar color="secondary">
              {{ (useExistingProtocol || protocol?.id != null ?
              'executionEdit.protocol.title' :
              'executionEdit.execution.title') | translate }}
              @if (canEditDocumentCode()) {
                <div fxFlex="65px" fxFlex.lt-md="50px">
                  <button mat-icon-button (click)="editDataExecution()">
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                </div>
              }
            </mat-toolbar>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              <div fxFlex="100" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'executionEdit.general.client.label' | translate
                  }}</mat-label>
                  <mat-select #clientSelect required name="idClient" name="idClient"
                    [(ngModel)]="execution.idClient" [disabled]="+execution.signedVersion > 0">
                    @if (clientSelect.focused) {
                      <mat-select-filter [displayMember]="'name'"
                        [array]="clients" (filteredReturn)="clientsFiltered =$event"
                        [noResultsMessage]="'common.noResults' | translate"
                        [placeholder]="'common.selectFilterPlaceholder' | translate">
                      </mat-select-filter>
                    }
                    @for (client of clientsFiltered; track client) {
                      <mat-option [value]="client.id">
                        {{client.name}} ({{client.address}})
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error>
                    {{ 'executionEdit.general.client.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'executionEdit.general.projectNo.label' | translate }}</mat-label>
                  <input matInput name="projectNo" [(ngModel)]="execution.projectNo" required
                    [errorStateMatcher]="matcher">
                  <mat-error>
                    {{ 'executionEdit.general.projectNo.label' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'executionEdit.general.projectManager.label' |
                    translate }}
                  </mat-label>
                  <mat-select name="projectManager" [(ngModel)]="execution.usernameProjectManager">
                    <mat-option>--</mat-option>
                    @for (item of respField; track item) {
                      <mat-option [value]="item.username">
                        {{ item.fullName }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }

      <mat-card class="card" [hidden]="execution.id == null">
        <mat-card-content>
          <br />

          <mat-toolbar color="secondary">
            {{ 'protocolEdit.equipment.title' | translate }}

            @if (execution.equipments?.length === 0) {
              <button mat-icon-button color="accent" (click)="openDialogEquipment()">
                <mat-icon>add</mat-icon>
              </button>
            }
          </mat-toolbar>

          <mat-accordion>
            @for (equipment of execution.equipments; track equipment; let indexEquipment = $index) {
              <mat-expansion-panel class="overflowX"
                (afterExpand)="equipmentTab = indexEquipment" (closed)="equipmentTab = null">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div style="margin: auto 0;display: block;">
                      {{ equipment.equipment }}
                      -
                      {{ equipment.model }}({{ equipment.serialNumber }})
                    </div>
                    @if (equipmentTab === indexEquipment) {
                      <button mat-icon-button color="accent"
                        (click)="openDialogEditEquipment(indexEquipment)">
                        <mat-icon style="font-size: 20px;">mode_edit</mat-icon>
                      </button>
                    }
                    @if (equipmentTab === indexEquipment) {
                      <button mat-icon-button color="accent"
                        (click)="deleteEquipment(indexEquipment)">
                        <mat-icon style="font-size: 20px;">delete</mat-icon>
                      </button>
                    }
                    @if (equipmentTab === indexEquipment && false) {
                      <button mat-icon-button color="accent"
                        (click)="duplicateEquipment(indexEquipment)">
                      </button>
                    }
                  </mat-panel-title>
                </mat-expansion-panel-header>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-card-content>
      </mat-card>
      @if (execution.id != null && testQualificationTypeList?.length > 0) {
        <mat-card class="card">
          <mat-card-content>
            <mat-toolbar color="secondary">
              {{ 'protocolEdit.testQualification.title' | translate }}
            </mat-toolbar>
            @for (test of testQualificationTypeList; track test; let indexTest = $index) {
              <div [hidden]="execution.id == null"
                >
                @if (test.testQTypes?.length > 0) {
                  <div fxLayout="column">
                    <span style="font-weight: 600; display: block; margin-top: 10px;">
                      {{ 'testQualification.title.' + test.qualificationType | translate }}
                    </span>
                    @for (item of test.testQTypes; track item) {
                      <div fxFlex="100">
                        <div fxFlex="100" style="margin-top: 10px;">
                          <div fxFlex="40">
                            <span class="test-item-verification">
                              {{ !item.name ? ('testQualification.' + item.translation | translate) : item.name }}
                            </span>
                            <!--<mat-checkbox [(ngModel)]="item.checked" [ngModelOptions]="{standalone: true}"
                            (change)="onSelectedItem(item, indexTest, $event)" [disabled]="true">
                          </mat-checkbox>-->
                        </div>
                        <div fxFlex="5">
                          @if (item.checked) {
                            <button mat-raised-button
                              (click)="validTestSelected(test, item)" style="box-shadow: none !important">
                              <mat-icon fxHide.lt-sm
                              [ngStyle]="isCompletedTest(item.id) ? {'color': 'green'} : {'color': 'none'}">display_settings</mat-icon>
                            </button>
                          }
                        </div>
                        <div fxFlex="5">
                          @if (showBtnDeviation(item.id)) {
                            <button mat-raised-button style="box-shadow: none !important"
                              (click)="showDeviationSelected(item.idExecutionTest)">
                              <mat-icon style="color: #8f5da0"> note_add</mat-icon>
                            </button>
                          }
                        </div>
                        <div fxFlex="5">
                          @if (!showExecute() && isValidateTest(item)) {
                            <div mat-raised-button style="box-shadow: none !important"
                              >
                              <mat-icon fxHide.lt-sm
                              [ngStyle]="isValidateTest(item) ? {'color': 'green'} : {'color': 'none'}">check</mat-icon>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>
    }

    <mat-card class="card" [hidden]="execution.id == null">
      <mat-card-content>
        <div fxLayout="column">
          <mat-toolbar color="secondary">
            <span> {{ 'executionEdit.deviations.title' | translate }}</span>
          </mat-toolbar>

          <div class="table-container">
            <table #deviations mat-table matSort [dataSource]="execution.deviations">

              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'desviationList.cols.code' | translate }}
                </th>
                <td mat-cell *matCellDef="let item">
                  {{ item.codeDeviation }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'desviationList.cols.modDate' | translate }}
                </th>
                <td mat-cell *matCellDef="let item">
                  {{ item.modDate | fixDateTime }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modUser">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'desviationList.cols.modUser' | translate }}
                </th>
                <td mat-cell *matCellDef="let item">
                  {{ item.modUser }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card" [hidden]="execution.id == null">
      <mat-card-content>
        <div fxLayout="column">
          <mat-toolbar color="secondary">
            <span>Observaciones</span>
          </mat-toolbar>
          <div fxFlex="100" class="table-item">
            <!--<mat-form-field style="width: 100%;">
            <textarea matInput [(ngModel)]="execution.observations" name="observations"
              id="observations" rows="6"
              style="height: 150px; font-weight: normal; background-color: white;">
            </textarea>
          </mat-form-field>-->
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <app-execution-q-edit-attachments #attachmentsComponent>
  </app-execution-q-edit-attachments>

  <mat-card class="card">
    <mat-card-actions>
      <div fxFlex></div>
      @if (showBack()) {
        <button mat-raised-button color="primary" (click)="calculateBack()" [disabled]="disabledSigned()">
        {{ 'button.retreat' | translate }} </button>
      }
      <div fxFlex="5px"></div>
      <!--<button mat-raised-button color="primary" *ngIf="showRevertSign()" (click)="revertSign()">
    {{ 'button.revertSign' | translate }} </button>-->
    @if (showExecute()) {
      <div fxFlex="5px"></div>
    }
    @if (showExecute()) {
      <button mat-raised-button color="primary" [disabled]="disabledSigned()" (click)="execute()">
        {{ 'button.advance' | translate }}
      </button>
    }
    <div fxFlex="5px"></div>
    <button mat-raised-button color="primary" [disabled]="disabledSigned()" (click)="saveExecution()">{{ 'button.save' | translate }}
    </button>
    <div fxFlex="5px"></div>
    <!--<div matTooltip="{{ 'button.disabled.offline' | translate }}">
    <button mat-raised-button color="primary" [disabled]="showManualSign()" (click)="manualSign()">
      {{ 'button.sign-manual' | translate }}
    </button>
  </div>-->
  <div fxFlex="5px"></div>
  @if (showAutomaticSign()) {
    <button mat-raised-button color="primary" (click)="prepareToSign()">
      {{ 'button.sign-automatic' | translate }}
    </button>
  }
  @if (showSignature()) {
    <div fxFlex="5px"></div>
  }
  @if (showSignature()) {
    <button mat-raised-button color="primary" (click)="prepareToSigner()">
      {{ 'button.manageSign' | translate }}
    </button>
  }
  <div fxFlex="5px"></div>
  @if (execution.documentCode != null) {
    <button mat-raised-button color="accent"
      (click)="downloadPdf()">{{ 'button.generateDoc' | translate }}
    </button>
  }
  <div fxFlex="5px"></div>
  <button mat-raised-button color="secondary" (click)="cancel()">{{ 'button.cancel' | translate
  }}</button>
</mat-card-actions>
</mat-card>
</form>
</mat-tab>

@if (execution.id != null) {
  <mat-tab label="{{ 'executionEdit.historical.title' | translate }}">
    <app-execution-edit-q-audit [idExecution]="execution.id" [documentCode]="execution.documentCode">
    </app-execution-edit-q-audit>
  </mat-tab>
}
</mat-tab-group>